(() => {
  const technical = /^(?:materials?|metal|finish|stones?|pearls?|pearl size|size|measurements?|dimensions?|length|width|height|weight|necklace length|chain length|pendant length|overall length|ring inner|decorative face|skin comfort|colour|color)\s*:/i;
  const populate = scope => {
    const panel = scope.querySelector('[data-nm-details]');
    const intro = scope.querySelector('[data-nm-intro]');
    if (!panel || !intro || panel.dataset.nmReady) return;
    const body = panel.querySelector('[data-nm-description]');
    if (!body) return;
    panel.dataset.nmReady = 'true';
    for (const node of [...body.children]) {
      if (node.tagName !== 'P') break;
      const text = node.textContent.trim();
      if (!text) { node.remove(); continue; }
      if (technical.test(text) || /^(?:approx\.?\s*)?\d[\d.\s–—-]*(?:mm|cm)\b/i.test(text)) break;
      intro.append(node);
    }
    intro.hidden = !intro.children.length;
    const details = body.closest('details');
    details.open = false;
    if (!body.textContent.trim()) details.hidden = true;
  };
  const start = () => {
    document.querySelectorAll('product-info[data-section-type="main-product"]').forEach(scope => {
      populate(scope);
      if (scope.dataset.nmObserver) return;
      scope.dataset.nmObserver = 'true';
      new MutationObserver(() => populate(scope)).observe(scope, {childList:true, subtree:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
